import { restApiIP } from "@plannel/services/utils/rest-api";
import ResponseUtil from "@plannel/pages/utils/response-util";

const user = JSON.parse(localStorage.getItem("user"));
const getAll = (params) => {
  return restApiIP.get("/api/monthly/category/location", { params });
};

const getDetailAll = (params) => {
  return restApiIP.get("/api/monthly/category/location/detail", { params });
};

const getAllForRawCSV = params => {
  params = ResponseUtil.getExportUrlSearchParameter(params)
  return fetch(`/api/monthly/category/location/detail/raw-csv?${params}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": user.tenantId,
      Authorization: `${user.type} ${user.accessToken}`,
      "x-module-name": "IP"
    }
  });
};

const monthlyCategoryLocationService = {
  getAll,
  getAllForCSV: getAll,
  getDetailAll,
  getDetailAllForCSV: { getAllForCSV: getDetailAll, getAllForRawCSV }
};

export default monthlyCategoryLocationService;